{
  "confirm": {
    "confirmToDeleteMediaAndRemoveFromProjects": "Delete and Remove from Project | Delete and Remove from Projects",
    "unsavedChanges": "Unsaved Changes!",
    "areYouSureYouWantToRemovePage": "Delete '{pageName}'.",
    "deleteStyle": "Delete Style?",
    "deleteMedia": "Delete Media?",
    "deleteMediaImplications": "Delete and remove from projects?",
    "deletePlayer": "Delete Player?",
    "deletePlayerImplications": "This action will remove the player from your ARYA account and delete all settings related to this player including all scheduling.",
    "permanentlyDeleteTheUserAccount": "Delete Account.",
    "removeTemplate": "Remove Template",
    "removeTemplateDesc": "Do you want to remove this template from this style?",
    "removeTheMediaFromTheSchedule": "Delete from Schedule.",
    "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Delete Media.",
    "mediaUsedInProject": "Media Used in Project | Media Used in Projects",
    "confirmPassword": "Confirm Password",
    "changeEmail": "Change Email",
    "deleteOrder": "Delete Order",
    "deleteTag": "Delete Tag?",
    "deletePopId": "Delete PoP ID?",
    "deleteUser": "Delete User?",
    "deleteAccount": "Delete Account?",
    "leaveAccount":"Leave Account?",
    "deleteCanvasResolution": "Delete Canvas Resolution?",
    "downloadLicense": "Download License?",
    "cancelOrder": "Cancel Order?",
    "removeAccessFromArya": "Remove Access from ARYA?",
    "deleteTemplate": "Delete Template?"
  },
  "signinup": {
    "new": "New to {productNameShort}?",
    "newUser": "New User"
  },
  "label": {
    "aryaAccountID": "Arya Account ID",
    "accountId": "Account ID",
    "admin": "admin",
    "addPlayer": "Add Player",
    "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "The code {code} has already been assigned in another account.",
    "assignCodeHasAlreadyBeenAssignedErrorMessage": "The code {code} has already been assigned.",
    "account": "Account | Accounts",
    "accountInfo": "Account Info",
    "accountInformation": "Account Information",
    "accountName": "Account Name",
    "accountPlan": "Account Plan",
    "accountCorrespondent": "Account Correspondent",
    "accountIsDeleted": "Account has been deleted",
    "activate": "activate",
    "address": "address",
    "alert": "alert | alerts",
    "amount": "amount",
    "apply": "apply",
    "assign": "assign | assigns",
    "audio": "audio",
    "auto": "auto",
    "basic": "basic",
    "bannerText1": "Scheduled Maintenance",
    "bannerText2": "We will be undergoing scheduled maintenance on {date} at {time} for approximately {approximateHours} hours. We apologize for any inconvenience caused during this time.",
    "bannerText3": "During maintenance {productName} will be unavailable for content modifications, but players will continue to display their content.",
    "billing": "billing",
    "billingDetails": "Billing Details",
    "buy": "buy",
    "comment": "comment",
    "companyInformation": "Company Information",
    "contentNotSupported": "content not supported, click for more info…",
    "copy": "copy | copies",
    "configPending": "CONFIG PENDING",
    "configError": "CONFIG ERROR",
    "credentials": "credentials",
    "credentialsNotValid": "Credentials Not Valid",
    "createStyle": "Create Style",
    "createUserExistErrorMessage": "{email} is already a member of this account.",
    "createUserLimitReached": "User limit reached",
    "creditCard": "Credit Card",
    "download": "Download",
    "extended": "extended",
    "expirationDate": "Expiration Date",
    "expires": "expires",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "language": "Language",
    "learnMore": "learn more",
    "leaveAccount": "Leave Account",
    "leaveAccountWithOnlyOneUserMessage": "You cannot leave the account as you are the only user in the account.",
    "leaveAccountTheOnlyAdminInTheAccountMessage": "You cannot leave the account as you are the only admin in the account.",
    "leaveAccountImplicationsCommonMessage": "This action will remove you from this account.",
    "license": "license",
    "limited": "limited",
    "location": "Location",
    "login": "Log In",
    "loginError": "Something went wrong, we cannot sign you in at this moment, please retry later or contact your administrator",
    "loginWith": "Log in with",
    "loginString2": "Content on Screen at once. Free.",
    "loginString3": "Simplicity meets Digital Signage.",
    "loginString4": "Order and Activate Feature Sets Seamlessly",
    "loginOKStringTitle2": "Simplicity Meets Smart Sync.",
    "loginOKStringDesc1": "Customize it. Schedule it. Prioritize it.",
    "loginOKStringDesc2": "Tag it. Smart Sync it. Alert if necessary.",
    "loginOKString4": "Next Step. Quick player setup.",
    "loginOKString5": "All you need is your player's serial number.",
    "loginOKQuotaWarnMain": "Free Storage {percentage}% Full.",
    "loginOKQuotaWarnSub": "Upgrade to {plan} for fully customizable templates and alerts, 10GB storage per player, 10 users, tags and smart tags sync, and so much more.",
    "loginOKQuotaReachedMain": "Free Storage {percentage}% Full.",
    "loginOKQuotaReachedSub": "Upgrade to {plan} for fully customizable templates and alerts, 10GB storage per player, 10 users, tags and smart tags sync, and so much more.",
    "loginOKQuotaExcededMain": "Free Storage Full.",
    "loginOKQuotaExcededSub": "Upgrade to {plan} for fully customizable templates and alerts, 10GB storage per player, 10 users, tags and smart tags sync, and so much more.",
    "logoutOKStringTitle1": "YOU ARE NOW SIGNED OUT",
    "logoutOKStringDesc1": "You can sign in again by clicking on button below.",
    "notice": "notice",
    "playerSetupString1": "Create Your Project.",
    "playerSetupString2": "It's super easy. It's super quick.",
    "playerSetupString3": "",
    "payments": "payments",
    "pageNotFound": "Sorry, Page Not Found",
    "plan": "plan | plans",
    "popIdentifier": "PoP IDENTIFIER",
    "postalCode": "Postal Code",
    "purchasePlanUpgradeSuccessMain": "Welcome to {plan}",
    "purchasePlanDowngradeSuccessMain": "Account has been downgraded to {planName}",
    "loggedOffInFewSeconds": "You will be logged off in few seconds",
    "termsOfServiceString1": "Terms of Service",
    "termsOfServiceString2": "Last Updated: 9 January 2019",
    "termsOfServiceString3": "Please download and read the following document",
    "termsOfServiceString4": "TERMS OF SERVICE",
    "termsOfServiceString5": "PRIVACY POLICY",
    "termsOfServiceString6": "Select ACCEPT to continue.",
    "accept": "accept",
    "all": "All",
    "allPlayers": "All Players",
    "add": "Add",
    "setPassword": "Confirm",
    "support": "support",
    "cancel": "cancel",
    "canvasSize": "Canvas Size: {size} pixels",
    "canvasExistsError": "Canvas with this size already exists",
    "cardType": "card type",
    "cardNumber": "card number",
    "change": "change",
    "clickToEdit": "click to edit",
    "city": "city",
    "color": "color | colors",
    "company": "company",
    "companyName": "Company Name",
    "confirm": "Confirm",
    "confirmation": "Confirmation",
    "warning": "Warning",
    "codeIsRequired": "Verification Code required",
    "code": "Code",
    "contact": "contact",
    "country": "country",
    "create": "Create",
    "checkThePlayer": "Connect to the Internet. Connect Power.",
    "checkDetails": "Check Details",
    "chooseHorizontalOrVerticalScreenOrientations": "Choose screen orientation",
    "continue": "Continue",
    "conctactSystemAdmin": "Please contact your system admin.",
    "custom": "custom",
    "customerInfo": "Customer Info",
    "date": "date",
    "dropFilesHere": "Drop files here",
    "deactivate": "deactivate",
    "default": "default",
    "delete": "delete",
    "deleteAccount": "delete account",
    "deleteUser": "delete user",
    "deleteOnAllPlayers": "DELETE on ALL PLAYERS.",
    "deleteFromSchedule": "Delete from Schedule",
    "demoVersion": "Demo Version",
    "disable": "disable",
    "disabled": "disabled",
    "distributor": "distributor",
    "downgradeAccount": "Downgrade Account",
    "downgradeTo": "Downgrade to {plan}",
    "duplicate": "Duplicate",
    "duplicateFile": "Duplicate File",
    "duplicateInSchedule": "Duplicate in Schedule",
    "duration": "Duration",
    "adsDuration": "Ads Duration",
    "error": "Error",
    "email": "email",
    "emailAlreadyExists": "The new email address is already being used by another user, please use a different one.",
    "enable": "enable",
    "enabled": "enabled",
    "endDate": "End",
    "endTime": "End",
    "end": "end",
    "edit": "Edit",
    "editProject": "Edit Project",
    "feedbackForm": "Give Feedback",
    "firstName": "First Name",
    "firmwareUpdate": "FIRMWARE UPDATE",
    "failed": "Contact Support",
    "file": "File | Files",
    "forgotPassword": "Forgot Password",
    "formatNotSupported": "'{format}' files not supported.",
    "firmware": "Firmware",
    "freeVersion": "Free Version",
    "freeVersionNA": "N/A Free Version",
    "get": "get",
    "getCode": "Get Config",
    "getConfig": "Get Config",
    "generateNewAPIKey": "Generate New API Key",
    "generateUserAPIKeyWarningMessage": "This action will render the previous API key invalid, any existing connection to the API will need to be reconfigured to use the new API key.",
    "goBack": "Go Back",
    "goToLogin": "Go to Login",
    "helpCenter": "Help Center",
    "horizontalView": "Horizontal View",
    "image": "Image | Images",
    "implications": "implications",
    "implicationsDeleteTag": "This action will delete this tag from all {deleteFrom}. This could affect your user permissions and schedule.",
    "implicationsDeleteLedTag": "This action will delete this tag from all players. Any player that had this tag will need to be reconfigured if content with this resolution can be published to it again.",
    "implicationsDeletePopId": "This action will delete this PoP ID everywhere it is used.",
    "importantToNote": "Important to note",
    "logo": "logo",
    "userProfile": "User Profile",
    "userSignOut": "Sign out",
    "userNotConfirmed": "User not confirmed",
    "userNotFound": "User does not exist. Please make sure this account exits",
    "userManagement": "User Management",
    "id": "id",
    "incorrectUsername": "Incorrect email",
    "incorrectPassword": "Incorrect Password",
    "installedOrCapacity": "Installed / Capacity",
    "installed": "Installed",
    "installedOrCapacityUnlimitedMaxValue": "of Unlimited Players",
    "invalidEmail": "Invalid email",
    "invalidPassword": "Invalid password",
    "invalidUserdata": "Contact Support",
    "invalidSerialNumber": "Incorrect Serial Number",
    "invalidDSOSTypeAmount": "Invalid value, Please enter a number.",
    "invalidResolution": "Invalid resolution",
    "invoice": "invoice | invoices",
    "inviteUser": "Invite User",
    "requiredDeviceName": "Name required",
    "regular": "regular",
    "resetPassword": "Reset Password",
    "loading": "Loading...",
    "lastName": "Last Name",
    "lastLogin": "Last Login",
    "modify": "modify",
    "monitoring": "monitoring",
    "newPassword": "New Password",
    "newPasswordRequiredWarning": "Set your password",
    "confirmNewPassword": "Confirm New Password",
    "new": "New",
    "newCanvas": "New Canvas",
    "newProject": "new project",
    "newEmail": "New Email",
    "newResolution": "New Resolution",
    "name": "name",
    "naText": "N/A",
    "next": "next",
    "nextRenewalDate": "Next renewal {renewalDate}",
    "noVideoAvailable": "No video available.",
    "noEmailProvided": "No email provided",
    "none": "none",
    "noSearchResults": "no results",
    "noPermissionToAccessThePage": "Access denied",
    "noPlayersInstalled": "No players installed",
    "noPlayerGroupsAvailable": "No player groups available",
    "notConfigured": "Setup Required",
    "nameYourPlayerEGReception": "Name your player, e.g. Reception",
    "ok": "OK",
    "or": "or",
    "orders": "orders",
    "order": "order | orders",
    "offline": "Offline",
    "online": "online",
    "options": "options",
    "page": "Page",
    "player": "player | players",
    "playerName": "Player Name",
    "playerModel": "Player Model",
    "playerGroups": "Player Groups",
    "pleaseEnterACity": "Enter city",
    "pin": "PIN",
    "pinShownOnYourScreen": "PIN shown on your screen",
    "playTime": "Play Time",
    "PleaseTryAgainOrHeadBackToTheHomepage": "Please try again, or go back to the homepage",
    "playerIsNotConnectedToTheCloud": "Incorrect Serial Number",
    "pleaseTryAgain": "Try Again",
    "pleaseEnterThePin": "PIN required",
    "pleaseEnterValidPin": "Enter 4 or 6 digit number shown on your screen",
    "pinMustBeFourDigitNumber": "PIN must be 4 to 6 digit number",
    "pinMustBeAtleastOneThousand":"The PIN must be at least 1000",
    "pleaseCheckYourEmailForVerificationCode": "Verification Code sent to your email",
    "password": "password",
    "passwordDidNotMatch": "Password does not match",
    "passwordCannotBeReset": "Password connot be reset",
    "passwordHasBeenChanged": "Your password has been changed",
    "passwordAttemptLimitExceeded": "Attempt limit exceeded, please try after some time.",
    "passwordPolicyRequirementText": "Password must be 8 or more characters long, with uppercase, lowercase, number and special characters.",
    "price": "Price",
    "priceSlashMonth": "Price/Month",
    "priority": "priority",
    "privacy": "Privacy",
    "project": "Project | Projects",
    "projectName": "Project Name",
    "profile": "Profile",
    "proofOfPlay": "Proof of Play",
    "preview": "Preview",
    "previewUnavailable": "Preview Unavailable",
    "proceed": "proceed ",
    "publishTo": "Publish To",
    "releaseNotes": "Release Notes",
    "remove": "remove",
    "removeUserFromAccount": "Remove user from account",
    "replace": "replace",
    "reporting": "reporting",
    "reset": "reset",
    "restart": "restart",
    "resolution": "resolution",
    "reactivate": "reactivate",
    "resetPasswordDescription": "Enter email to receive Verification Code",
    "resetPasswordCodeSent": "Verification Code sent to your email",
    "resetPasswordCodeSentIfAccountExist": "IF ACCOUNT EXISTS",
    "requiredAccountName": "Account Name required",
    "requiredEmail": "Email required",
    "requiredCountry": "Country required",
    "requiredPassword": "Password required",
    "requiredConfirmPassword": "Confirm Password required",
    "requiredFirstName": "First Name required",
    "requiredLastName": "Last Name required",
    "requiredName": "Name required",
    "requiredUsername": "Email required",
    "requiredVerificationCode": "Verification Code required",
    "requiredSerialNumber": "Serial Number required",
    "requiredCity": "City required",
    "requiredState": "State required",
    "requiredZipOrPostalCode": "Postal Code required",
    "requiredStreetAndNumber": "Street and Number required",
    "requiredCompanyName": "Company Name required",
    "requiredDataStorageRegion": "Data Storage Region required",
    "invalidDataStorageRegion": "Invalid Data Storage Region",
    "review": "review",
    "signOut": "signout",
    "search": "Search",
    "addressSearchPlaceholder": "Type Address to Locate Players",
    "searching": "searching",
    "status": "status",
    "save": "save",
    "reconfigure": "Restart Set-Up",
    "saveAs": "Save As",
    "saveChanges": "Save Changes",
    "savedStyles": "Saved Styles",
    "schedule": "schedule",
    "scheduledToTag": "Scheduled To Tag",
    "screen": "screen",
    "screenOn": "Screen On",
    "screenOrientation": "Screen Orientation",
    "security": "Security",
    "sendCode": "Send Code",
    "sendEmail": "Send",
    "sendInvitation": "Send Invitation",
    "sendTo": "Send To",
    "serial": "Serial Number",
    "serialNumber": "Serial Number",
    "serialNumberAlreadyAssigned": "Serial Number already assigned",
    "select": "SELECT",
    "selectAll": "select all",
    "selectLanguage": "select language",
    "setup": "Setup",
    "settings": "settings",
    "shapeColors": "Shape Colors",
    "shareWithText": "{productShortName} Digital Signage. Simple. Smart. Powerful.",
    "signIn": "Sign in",
    "signUp": "Sign up",
    "signUpErrorMessageAccountEmailExist": "An account with the given email already exists.",
    "slowSync": "SLOW SYNC ",
    "sorry": "Sorry.",
    "streetAndNumber": "Street and Number",
    "success": "success",
    "summary": "summary",
    "somethingWentWrong": "Something Went Wrong",
    "song": "Song | Songs",
    "startDate": "Start Date",
    "startTime": "Start",
    "start": "Start",
    "state": "state",
    "steps": "steps",
    "styleName": "Style name",
    "storage": "storage",
    "subtotal": "subtotal",
    "subscription": "subscription",
    "subscriptionMonthlyAutoRenew": "Monthly (Auto-Renew)",
    "ssoLoginErrorTitle": "Something went wrong, we cannot sign you in at this moment, please retry later or contact your administrator",
    "ssoMigrateAccountStep1Title1": "An account for {email} already exists.",
    "ssoMigrateAccountStep1Title2": "You can switch it to use {provider} SSO.",
    "ssoMigrateAccountStep1Title3": "Proceed to confirm the switch.",
    "ssoMigrateAccountStep2Title1": "Once you confirm the switch to {provider} SSO,",
    "ssoMigrateAccountStep2Title2": "your previous sign in will no longer work.",
    "ssoMigrateAccountStep2Title3": "This action cannot be undone.",
    "ssoMigrateAccountVerifyTitle1": "We need to verify your existing {email} account.",
    "ssoMigrateAccountVerifyTitle2": "Please sign in with that account to proceed.",
    "tag": "tag | tags",
    "defaultTags": "Default Tags",
    "text": "text",
    "deleteAccountWithMultipleUsersMessage": "You must remove all other users before you can delete this account.",
    "deleteAccountWithDistributorRightsMessage": "This account cannot be deleted. It is owned by a distributor.",
    "deleteAccountTitleThisActionWill": "This action will",
    "deleteAccountImplications": {
      "deleteAccount": "1. Delete Account",
      "deleteUser": "2. Delete User"
    },
    "youCannotDeleteUserAsOnlyUserInAccount": "You cannot delete user as you are the only user in the account.",
    "timeZone": "Time Zone",
    "time": "time",
    "timeShorthandSecond": "SEC",
    "timeShorthandMinute": "MIN",
    "timeShorthandHour": "H",
    "template": "Template | Templates",
    "temporaryPassword": "temporary password",
    "tempPasswordExpiredPleaseContactAdmin": "Temporary password has expired. Please contact your administrator",
    "total": "total",
    "tutorial": "Tutorial | Tutorials",
    "user": "user | users",
    "userAPIKey": "API Key",
    "userNotActive": "User not active",
    "usernameShouldBeValidEmail": "Username should be a valid email",
    "updatedAccountInfo": "Your account information has been updated.",
    "updatedCustomerInfo": "Your customer information has been updated.",
    "updatedProfile": "Your user profile has been updated.",
    "updated": "updated",
    "upload": "Upload",
    "upTime": "up time",
    "upgrade": "upgrade",
    "video": "Video",
    "vat": "VAT",
    "verificationCode": "Verification Code",
    "verticalView": "Vertical View",
    "withResolution": "with {resolution} resolution",
    "yourPlan": "your plan",
    "youHaveLeftAccount": "You have left account",
    "zipOrPostalCode": "ZIP",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Sun",
    "apps": "apps",
    "multiplePopIdsNotAllowed": "Each file may only have one Proof of Play Identifier.",
    "forbidden": "Something went wrong, and we couldn't complete your request. You will be redirected to the homepage soon.",
    "dataStorageRegion": "Data Storage Region",
    "verificationSentToEmailIfExist": "Verification Code sent to your Email (If Account exists)",
    "alreadyHaveAnAccountRedirect": "Already have an account? {linkStart}Log In{linkEnd}",
    "emailText": "Email",
    "passwordText": "Password",
    "signupWith": "Sign up with",
    "setNewPassword": "Set Password",
    "passwordHint": "{minStart}Minimum 8 characters,{minEnd} {upStart}uppercase,{upEnd} {lowStart}lowercase,{lowEnd} {numStart}number{numEnd}{numSpecialSeparatorStart} & {numSpecialSeparatorEnd}{spStart}special character{spEnd}.",
    "home": "Home",
    "loginWithName": "Log in with {name}",
    "signupWithName": "Sign up with {name}",
    "fileType": "File Type",
    "lastModified": "Last Modified",
    "images": "Images",
    "videos": "Videos",
    "projectsOrPdf": "Projects / PDF",
    "elementiProject": "Elementi Projects",
    "scheduled": "Scheduled",
    "notScheduled": "Not Scheduled",
    "from": "From",
    "to": "To",
    "fileTypes": "File Types",
    "contentStatus": "Content Status",
    "modifiedDate": "Modified Date",
    "filters": "Filters",
    "sortBy": "Sort By",
    "sort": "Sort",
    "lastModifiedDesc": "Last Modified (Newest First)",
    "lastModifiedAsc": "Last Modified (Oldest First)",
    "nameAsc": "Name (A → Z)",
    "nameDesc": "Name (Z → A)",
    "grid": "Grid",
    "canvas": "Canvas",
    "audioPlaylist": "Audio Playlist",
    "isAlertActive": "Is Alert Active",
    "active": "Active",
    "inactive": "Inactive",
    "filesPage": "Files Page",
    "ledPage": "LED Page",
    "videowallPage": "Videowall Page",
    "alertPage": "Alert Page"
  },
  "buttons": {
    "backToProduct": "Back to {productName}",
    "reload": "Reload",
    "previous": "Previous",
    "next": "Next",
    "loadMore": "Load More",
    "addNewUser": "Add New User",
    "apply": "Apply",
    "clearAll": "Clear All",
    "reset": "Reset",
    "tryItNow": "Try it now",
    "switchBack": "Switch Back",
    "cancel": "Cancel",
    "deleteMedia": "Delete Media",
    "deletePlayer": "Delete Player",
    "deleteTag": "Delete Tag",
    "deletePopId": "Delete PoP ID",
    "deleteUser": "Delete User",
    "continueWithoutSaving": "Continue Without Saving",
    "close": "Close",
    "cancelOrder": "Cancel Order",
    "removeUser": "Remove User",
    "deleteTemplate": "Delete Template",
    "deleteStyle": "Delete Style",
    "ok": "OK",
    "delete": "Delete",
    "keepBoth": "Keep Both",
    "replaceExistingFile": "Replace Existing File",
    "replaceExistingFiles": "Replace Existing Files"
  },
  "texts": {
    "youAreLoggingIn": "You are logging in using",
    "productAccessDisabled": "You Don't Have Access to {product}",
    "productAccessDisabledWarning": "You don't have access to {product} for the {account} account.\n\nYou were either not given access to this product, or your access was revoked by the Global Admin. Please contact the Global Admin for more information or to request access.\n\nYou can continue to access other products that you have permission to use within this account.",
    "tablePageCountWTotal": "Showing {min}{separator}{max} of {total}",
    "tablePageCountWoutTotal": "Showing {min}{separator}{max}",
    "dataStorageRegionHint": "Choose the region where your account data will be stored. This decision should align with your local data protection laws and compliance needs. Please note: once selected, the data residency region cannot be changed later.",
    "welcomeToHUB": "Welcome to SpinetiX HUB!",
    "welcomeToHUBDesc": "SpinetiX HUB is your all-in-one online platform for managing everything related to your SpinetiX digital signage in a cloud.",
    "hubGlobalAdmin": "SpinetiX Global Admin",
    "hubGlobalAdminDesc": "This user is a Global Admin on the HUB, which automatically grants them the Admin role in ARYA. This role assignment cannot be modified.",
    "removeAccessFromAryaTitle": "Remove Access from ARYA?",
    "removeAccessFromAryaMessage": "This will remove {userName}'s access to ARYA only.",
    "hubUserManagement": "HUB User Management",
    "removeAccessFromAryaByGlobalAdmin": "They will still have access to other products in this HUB account.\n\nTo remove the user from the HUB account, please go to {link}",
    "removeAccessFromAryaByNonGlobalAdmin": "They will still have access to other products in this HUB account.\n\nTo remove the user from the HUB account, please contact your Global Admin.",
    "goToHUBUserManagement": "please go to HUB user management.",
    "noContentHasBeenScheduledYet": "No content has been scheduled yet.",
    "emptyFilterTablePlaceholder": "We couldn't find any items matching your search. Try adjusting your search terms and try again!",
    "requestId": "Request ID:",
    "externalSignInMessage": "You are signed in with an external identity provider (e.g., Google, Facebook, or SSO with another identity provider). Your credentials, including {email} and {password}, are managed by that provider.",
    "youHaveUnsavedChanges": "You have unsaved changes.",
    "waitForUploadingFile": "Uploading file, please wait...",
    "defaultTagsNote": "Projects inherit the Style Pack's tags when they're created from the template. If you add or remove tags from the Style Pack later, existing projects won't be updated.",
    "seeAll": "See All",
    "allPlayTimes": "All Play Times"
  },
  "switchedAccount": {
    "title": "Account switched",
    "desc1": "Welcome back.",
    "switch": "switch",
    "text1": "Account Switched",
    "text2": "to {account}"
  },
  "unsupportedBrowser": {
    "bannerTitle": "Your Browser is not supported",
    "bannerMessage": "You are using an unsupported browser. Some features may not work correctly. For the best experience with our product, please switch to {highlightStart}Google Chrome{highlightEnd} or {highlightStart}Microsoft Edge{highlightEnd}."
  },
  "plans": {
    "downgradedToFreeDesc": "{plan} plan is now enabled. Your credit card will be charged one last time at the end of the billing cycle",
    "free": "Free",
    "tags": "SMART SYNC & TAGS",
    "sharedStorage": "shared storage",
    "custom": "Custom & Alerts",
    "playerStorage": "Player Storage",
    "playerPerMonth": "player / month | players / month",
    "review": {
      "termsAndConditionsMain": "By placing your order you agree with",
      "termsAndConditionsSub": "SpinetiX Terms and Conditions of Sale"
    }
  },
  "filters": {
    "images": "images",
    "videos": "videos",
    "audio": "audio",
    "projectsOrPdf": "projects / PDF",
    "scheduled": "scheduled",
    "elementiProject": "elementi projects"
  },
  "template": {
    "24H": "24H",
    "AM/PM": "AM/PM",
    "addPage": "Add Page",
    "arrowSettings": "Arrow Settings",
    "back": "Back",
    "background": "Background",
    "both": "Both",
    "bottom": "bottom",
    "center": "center",
    "cellSettings": "cell Settings",
    "clock": "clock",
    "clockSettings": "Clock Settings",
    "countdown": "countdown",
    "countdownSettings": "Countdown Settings",
    "custom": "custom",
    "changeMedia": "Change Media",
    "default": "default",
    "duplicatePage": "duplicate page",
    "date": "date",
    "days": "days",
    "effects": "Effects",
    "fade": "Fade",
    "fill": "fill",
    "front": "Front",
    "frameFitting": "Frame Fitting",
    "hours": "hours",
    "imageEffects": "Image Effects",
    "kenBurns": "Ken Burns",
    "noEffect": "No Effect",
    "noBorder": "No Border",
    "noMargin": "No Margin",
    "L": "L",
    "large": "large",
    "left": "Left",
    "local": "local",
    "long": "long",
    "M": "M",
    "meet": "meet",
    "media": "media",
    "menu": "menu",
    "mediatable": "media table",
    "middle": "Middle",
    "month": "month",
    "overlay": "overlay",
    "overview": "overview",
    "playOnce": "Play Once",
    "qr": "qr",
    "reg": "reg",
    "repeat": "repeat",
    "right": "Right",
    "rss": "RSS",
    "shape": "shape",
    "shapeSettings": "Shape Settings",
    "shapeSettingsHint": "Hint: Start typing to add text",
    "slice": "slice",
    "slide": "Slide",
    "small": "small",
    "smart": "smart",
    "S": "S",
    "time": "Time",
    "timeAndDate": "TIME + DATE",
    "tableSettings": "Table Settings",
    "text": "text",
    "textSettings": "Text Settings",
    "top": "top",
    "wayfinding": "wayfinding",
    "weather": "weather",
    "html": "webpage",
    "url": "url",
    "videoin": "Video-In",
    "videoWidth": "video width",
    "videoHeight": "video height",
    "videoSettings" : "Video Settings",
    "frameRate": "frame rate",
    "frameWidth": "Select Width",
    "format": "format",
    "error": {
      "invalidLink": "Invalid Link"
    },
    "placeholder": {
      "url": "Enter URL"
    },
    "weatherIconSettings": "Weather Icon Settings",
    "weatherLocationSettings": "Weather Location Settings",
    "weatherLocationSettingsHint": "Hint: Type name of location",
    "webpageSettings": "Webpage Settings",
    "qrSettings": "QR Settings",
    "rssSettings": "RSS Settings",
    "rssSettingsTooltip": "RSS feeds offered by {productName} are sourced from <b>third-party providers</b>.<br>We strive to provide a diverse selection of feeds to meet your needs; however, their quality and performance are entirely dependent on the third-party providers.",
    "stream": "Stream",
    "list": "List"
  },
  "templates": {
    "duration": "Duration",
    "pageDuration": "Page Duration",
    "timezone": "Timezone",
    "tags": "Tags",
    "playtimes": "Playtime",
    "alignElements": "Align Elements",
    "removeTemplateConfirmation": "Are you sure you want to delete this template from the \"{styleName}\" style?",
    "deleteStyleConfirmation": "Are you sure you want to delete \"{styleName}\" style?",
    "deleteStyleWarning": "By deleting this style, you will remove all templates created in it.",
    "noTemplatesAvailable": "No templates available",
    "noStylePackAccess": "You don’t currently have access to any style packs containing templates. Style packs are only available when they are shared with you through your assigned permissions or tags.\nIf you think you should have access, please contact your account administrator."
  },
  "Hours": {
    "title": "Title",
    "time": "Hours",
    "media": "Media"
  },
  "Info": {
    "info": "Info",
    "title": "Title",
    "description": "Text",
    "media": "Media"
  },
  "Logo": {
    "title": "Text"
  },
  "Menu": {
    "menu": "Menu",
    "title": "Text",
    "price": "Price",
    "media": "Media"
  },
  "News": {
    "news": "News",
    "title": "Text",
    "timezone": "Time Zone",
    "format": "Format",
    "media": "Media"
  },
  "Person": {
    "person": "Person",
    "title": "Text Top",
    "description": "Text Bottom",
    "media": "Media"
  },
  "Product": {
    "product": "Product",
    "title": "Text",
    "price": "Price",
    "media": "Media"
  },
  "RSS": {
    "rss-news": "RSS News",
    "rss": "RSS",
    "news": "News"
  },
  "Weather": {
    "weather": "Weather",
    "locations": "City",
    "display": "Display",
    "media": "Media"
  },
  "playerSetup": {
    "navConfirm": "Confirm",
    "navFinish": "Finish",
    "navNext": "Next",
    "navPrev": "Back",
    "navCancel": "Cancel",
    "addPlayerToPlan": "Add player to your plan",
    "currentPlan": "Current Plan",
    "canvasName": "Canvas Name",
    "canvasVideoNote": "You will find your new canvas in the {canvasType} under this name.",
    "canvasVideoNoteType_led": "LED section",
    "canvasVideoNoteType_videowall": "Video Wall section",
    "canvasSize": "Canvas Size",
    "canvasSizeFormatted": "{canvasSize} pixels",
    "updateTo": "Update to",
    "numberOfPlayers": "Number of players",
    "dialogTitle": "Player Setup",
    "onlyDigitsRequired": "Please enter only digits",
    "serialNumberRequired": "Serial Number cannot be empty",
    "incorrectSerialNumber": "Please, enter correct serial number",
    "incorrectSerialNumberCharacters": "Please enter a valid input. You can only use English letters and numbers in this field",
    "incorrectInput": "Incorrect input",
    "playerName": "Name",
    "playerNamePlaceholder": "Player's name",
    "requiredPlayerName": "Player name is required",
    "requiredScreenDiagonal": "Screen Diagonal is required",
    "requiredHorizontalBezel": "Horizontal Bezel/Gap is required",
    "requiredVerticalBezel": "Vertical Bezel/Gap is required",
    "playerTimezoneHint": "Select Player's Time Zone",
    "Progress_PIN": "PIN",
    "Progress_Name": "Name & Time Zone",
    "Progress_DisplaySettings": "Display Settings",
    "Progress_Application": "Application",
    "Progress_Arrangement": "Arrangement",
    "Progress_Adjustments": "Adjustments",
    "DisplayOrientation": "Display Orientation",
    "DisplayResolution": "Display Resolution",
    "DisplayResolutionHint": "Select display resolution",
    "Application": "Application",
    "ApplicationSingleDisplay": "Single Display",
    "ApplicationMirroring": "Mirroring",
    "ApplicationVideowall": "Video Wall",
    "ApplicationAvailable": "* Available with",
    "ApplicationAvailbleWithNote": "*Available with",
    "screenDiagonal": "Screen Diagonal",
    "SelectApplication": "Select the Application",
    "SelectDisplayOrientation": "Select display orientation",
    "SelectNumberOfDisplays": "Select the number of displays",
    "standardScreenOnly": "Standard screen only (9:16 & 16:9)",
    "OrientationAndResolution": "Orientation and resolution settings will apply to all displays",
    "DisplaysArrangement": "Display Arrangement",
    "SelectDisplayArrangement": "Select display arrangement",
    "HorizontalBezel": "Horizontal Bezel/Gap",
    "VerticalBezel": "Vertical Bezel/Gap",
    "OutputResolutions": "Output Resolutions",
    "CannotCreateLEDTag": "Can't create an LED resolution",
    "CannotCreateVideowallTag": "Can't create Videowall canvas",
    "UnknownError": "Unknown error occured. Please, try again or contact support.",
    "InvalidAdjustmentsForm": "There are input validation errors, please fill all fields correctly",
    "CanvasDimensionsError": "Canvas width or height are not generated properly",
    "playerDeleteConfirmation": "Are you sure you want to delete player: {playerName}?",
    "playerDeleteWarning": "Deleting the player will remove it from your SpinetiX HUB account and delete all associated settings, including scheduling."
  },
  "planCard": {
    "getPremium": "Get Premium",
    "bestforGettingStarted": "Best for getting started",
    "discovery": "Discovery",
    "free": "Free",
    "oneUser": "1 User",
    "oneGBStorage": "1 GB Storage",
    "nineTemplates": "9 Templates",
    "yourPlan": "Your Plan",
    "elevateYourDigitalSignage": "Elevate your digital signage",
    "premium": "Premium",
    "premiumPlanPrice": "21 CHF",
    "playerPerMonth": "Player / Month",
    "tenUsersAndRoles": "10 Users & User Roles",
    "tenGBPlayerStorage": "10 GB / Player Storage",
    "twelveTemplatesCustomizable": "12 Templates / customizable",
    "twelveApps": "12 Apps including Webpage",
    "elevenApps": "11 Apps",
    "assetGrouping": "Asset grouping",
    "scheduleAutomation": "Schedule Automation",
    "priorityScheduling": "Priority Scheduling",
    "alerts": "Alerts",
    "audio": "Audio",
    "videoWallSupport": "Video Wall support*",
    "new": "New!",
    "withTheNew": "*With the new"
  },
  "planUpgrade" : {
    "errorFetchingInvoice": "Error fetching Invoice. Please try again.",
    "close": "close",
    "getPremium": "Get Premium!",
    "companyName": "Company Name",
    "dialogTitle": "Plan Upgrade",
    "navConfirm": "Confirm",
    "navFinish": "FINISH",
    "navNext": "Next",
    "navPrev": "Back",
    "navCancel": "Cancel",
    "VATNumber": "VAT Number",
    "Overview": "Overview",
    "AccountOwner": "Account Owner",
    "CompanyInfo": "Company Info",
    "BillingDetails": "Billing Details",
    "Payment": "Payment",
    "tryAgain": "TRY AGAIN",
    "paymentSuccessful": "Payment successful",
    "welcomeToPremium": "Welcome to Premium!",
    "paymentFailed": "Payment failed.",
    "selectCountry": "Select Country",
    "selectState": "Select State"
  },
  "licenseOrdering": {
    "yourOrders": "Your Orders",
    "cancelOrder": "CANCEL ORDER",
    "orderNumber": "Order Number",
    "orderDate": "Order Date",
    "comment1": "Comment 1",
    "comment2": "Comment 2",
    "close": "CLOSE",
    "cancelOrderWarning": "Are you sure you would like to cancel this order?",
    "noOrdersAvailable": "You have not placed any orders",
    "noRecordsFound": "No results found for query \"{query}\"",
    "noRecordsFoundNote1": "Please double-check for any typos or errors in your search",
    "noRecordsFoundNote2": "Try using different search query"
  },
  "fileUpload": {
    "notAllowedToUploadMedia": "User is not allowed to perform update on media.",
    "hashMD5ComputationError": "Something went wrong while computing hashMD5.",
    "duplicateFileUploadErrorTitle": "A file with this name already exists",
    "multipleDuplicateFileUploadErrorTitle": "Files with these names already exist",
    "duplicateFileUploadErrorDescription": "A file named \"{mediaName}\" already exists in your library.",
    "multipleDuplicateFileUploadErrorDescription": "Files named \"{mediaNames}\" already exist in your library.",
    "duplicateFileUploadErrorMessage": "Review the existing file(s) and choose what you would like to do with your new upload.\n{pleaseNote}: If you replace the existing file, reload the page after the upload finishes to see the updated version.",
    "duplicateFileUploadPreviewTitle": "Existing File(s)",
    "pleaseNote": "Please Note"
  },
  "downloadLicense": {
    "confirmDownloadLicense": "Are you sure? This method is exclusively for players which will not be connected to the Internet.",
    "confirmDownloadLicenseWarning": "Using this method will immediately associate the license to the serial number with no grace period for changes."
  },
  "activation": {
    "assign": "ASSIGN",
    "yourLicenses": "Your Licenses",
    "comment": "Comment",
    "playerSerialNumber": "Player Serial Number",
    "licenseCode": "License Code",
    "activationDate": "Activation Date",
    "license": "License",
    "suspend": "SUSPEND",
    "restore": "RESTORE",
    "download": "DOWNLOAD",
    "licenseAvailable": "License available ",
    "licenseLockedToAPlayer": "License locked to a player",
    "playerSerialNumberRequired": "Player SerialNumber Code required",
    "licenseCodeRequired": "License Code required",
    "processing": "Processing",
    "waitingForPlayerToConnect": "Waiting for player to connect",
    "noLicensesAvailable": "You have not added any licenses"
  },
  "resolutionCalculator": {
    "invalidPitch": "Invalid Pitch",
    "invalidSize": "Invalid Size"
  },
  "legal": {
    "legal": "Legal",
    "endUserLicenseAgreement": "END USER LICENSE AGREEMENT",
    "generalTermsAndConditionsOfSale": "GENERAL TERMS AND CONDITIONS OF SALE",
    "termsOfService": "TERMS OF SERVICE",
    "privacyPolicy": "PRIVACY POLICY",
    "cookieNotice": "COOKIE NOTICE",
    "downloadPDF": "DOWNLOAD PDF"
  },
  "accountSuspended": {
    "bannerTitle": "Your Subscription has expired!",
    "bannerMessage": "If you wish to renew, please contact your reseller."
  },
  "errors": {
    "invalid": {
      "verificationCode": "Invalid verification code provided, please try again.",
      "passwordReset": "Password cannot be reset.",
      "provider": "Invalid provider. Please try again.",
      "emailMismatch": "The email address you entered does not match the account you are trying to migrate."
    },
    "existing": {
      "userAlreadyLinked": "User is already linked to a different Identity Provider (IdP).",
      "accountInAnotherRegion": "User already has an account in another region"
    },
    "failedRefreshToken": "You have been logged out. Please log in again to continue.",
    "cannotMigrateAccountInAnotherRegion": "Cannot migrate to SSO because your email address is linked to a different data storage region than the account you are trying to migrate to.",
    "nonSSOAuthDenied": "Not allowed to authenticate via non-SSO Provider",
    "ssoMigrationFailed": "Access Denied: You cannot switch to SSO because your account is already linked to a different Identity Provider (IdP). Please contact your administrator for further assistance.",
    "loginUnexpectedError": "Login failed due to an unexpected error. Please try again.",
    "unexpectedError": "An unexpected error occurred. Please reload the page.",
    "somethingWentWrong": "Looks Like Something Went Wrong ({errorCode})",
    "somethingWentWrongDescription": "Something went wrong while loading this page.<br><br><strong>What you can do:</strong><br>Refresh the page and try again.<br>If it still doesn't load, please contact support and share the Request ID below.",
    "failedToUpdateAccountInfo": "Failed to update account information.",
    "failedToFetchLicenses": "Failed to fetch licenses.",
    "failedToDownloadLicense": "Failed to download license.",
    "failedToDownloadFile": "Failed to download file.",
    "failedToFetchUserInfo": "Failed to fetch user info",
    "failedToFetchPlaces": "Failed to fetch places",
    "fileNotSupported": "File type not supported."
  },
  "regionNames": {
    "eu": "European Union",
    "ch": "Switzerland",
    "us": "United States",
    "ca": "Canada",
    "au": "Australia",
    "hk": "Hong Kong",
    "sg": "Singapore"
  },
  "zendesk": {
    "chatCouldNotBeLoaded": "Chat Could Not Be Loaded",
    "chatCouldNotBeLoadedDescription": "We couldn't load the support chat. This is usually caused by your browser's privacy or cookie settings. For instructions on how to enable the support chat, click here: {url}."
  },
  "media": {
    "mediaUploadSuccessTitle": "Getting your media ready…",
    "mediaUploadSuccessMessage": "It may not appear in the current view due to active filters or sorting.",
    "mediaViewLegacyToV2Title": "Redesigned media pages",
    "mediaViewV2ToLegacyTitle": "You are using the new design!",
    "mediaViewSwitcherDescription": "Faster navigation, filters and sorting.",
    "mediaDeleteConfirmation": "Are you sure you want to delete \"{mediaName}\" media?",
    "multipleMediaDeleteConfirmation": "Are you sure you want to delete {mediaCount} selected media items?",
    "mediaDeleteWarning": "Deleting this media will also remove it from every project.",
    "multipleMediaDeleteWarning": "Deleting these media items will also remove them from every project that uses them.",
    "mediaFileUploadInfoMessage": "If you don't see them in your current view, they may be hidden by active filters or sorting.",
    "mediaIsReady": "Your media is ready!",
    "mediaIsReadyWithCount": "Your media is ready! ({count} of {total})",
    "someFilesUploadError": "Some files couldn't be processed",
    "failedUploadError": "Your files couldn't be processed. Try uploading them again.",
    "failedUploadErrorTitle": "We couldn't process your media"
  },
  "led": {
    "deleteCanvasConfirmation": "Are you sure? This action will delete this canvas resolution from all players.",
    "deleteCanvasWarning": "Any player that used this canvas resolution will need to be reconfigured before content with the same resolution can be published to it again."
  },
  "popId": {
    "deletePopIdConfirmation": "Are you sure? This action will delete this PoP ID everywhere it is used."
  },
  "tag": {
    "deleteTagConfirmation": "Are you sure? This action will delete this Tag from all {source}.",
    "deleteTagWarning": "This could affect your user permissions and schedule. "
  },
  "leaveAccount": {
    "leaveAccountConfirmation": "Are you sure you want to leave the account [{accountName}]?",
    "leaveAccountWarning": "By leaving this account, you will lose access to the account and all associated products and services currently available to you."
  },
  "userProfile": {
    "permanent": "permanent",
    "deleteUserConfirmation": "You are about to delete your user profile. This action is {permanent} and cannot be undone.",
    "lose": "lose",
    "deleteUserWarning": "By proceeding, you will {lose} access to all accounts and products associated with your user credentials.\nAre you sure you want to continue?"
  }
}
